import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { ConfigProvider, Grid } from 'antd';
import { useTheme } from '../../context/ThemeContext';
import { getAntdThemeConfig } from '../../utils/antdTheme';
import { AppDispatch, RootState } from '../../redux/store';
import { fetchPayments } from './store/paymentsSlice';
import {
  PageWrapper,
  HeaderWrap,
  PageTitle,
  PageSubtitle,
  SectionStack,
} from './Styles';
import { PAGE_TITLE, PAGE_SUBTITLE } from './constants';
import StatsCards from './StatsCards';
import PaymentTableSection from './PaymentTableSection';

const { useBreakpoint } = Grid;

const PaymentsAdmin: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { isDarkMode } = useTheme();
  const breakpoint = useBreakpoint();
  const isMobile = !breakpoint.md;

  const { pending, cleared, upcoming, loading } = useSelector(
    (state: RootState) => state.payments
  );

  useEffect(() => {
    dispatch(fetchPayments());
  }, [dispatch]);

  const themeConfig = useMemo(
    () => ({ mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' }),
    [isDarkMode]
  );
  const antdConfig = useMemo(() => getAntdThemeConfig(isDarkMode), [isDarkMode]);

  return (
    <ThemeProvider theme={themeConfig}>
      <ConfigProvider theme={antdConfig}>
        <PageWrapper>
          <HeaderWrap>
            <PageTitle>{PAGE_TITLE}</PageTitle>
            <PageSubtitle>{PAGE_SUBTITLE}</PageSubtitle>
          </HeaderWrap>
          <StatsCards />
          <SectionStack>
            <PaymentTableSection type="pending" data={pending} isMobile={isMobile} loading={loading} />
            <PaymentTableSection type="cleared" data={cleared} isMobile={isMobile} loading={loading} />
            <PaymentTableSection type="upcoming" data={upcoming} isMobile={isMobile} loading={loading} />
          </SectionStack>
        </PageWrapper>
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default PaymentsAdmin;
